const RectToolIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  const size = "24px";

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.75" y="2.65234" width="10.5" height="10.5" rx="1.25" stroke={finalColor} strokeWidth="1.5" />
    </svg>
  );
};

export default RectToolIcon;
